var dsox = dsox || {};
dsox.RepLocator = (function () {
    

    var findARepForm = function ($) {
        $(document).on('change', '.js-rep-locator-country', function(){
            $('.js-rep-locator-zip').val("");
            doAjaxCall($(this).closest('form'));
            dataLayer.push({
                event: "repLocatorCountry",
                repLocatorCountry: $(this).val()
            })
        })

        $(document).on('keydown input', '.js-rep-locator-zip', function(e){
            thisZip = $(this).val();
            if(e.type == "keydown"){
                var keycode = (e.keyCode ? e.keyCode : e.which);
                if(keycode == '13'){
                    e.preventDefault();
                    doAjaxCall($(this).closest('form'));

                    if(thisZip.length >=5){
                        dataLayer.push({
                            event: "repLocatorZip",
                            repLocatorZip: thisZip
                        })
                    }
                }
            } else {
                $('.js-rep-locator-country').prop('selectedIndex',0);
                if(thisZip.length >=5){
                    doAjaxCall($(this).closest('form'));
                    dataLayer.push({
                        event: "repLocatorZip",
                        repLocatorZip: thisZip
                    })
                }
            }
        })

        function doAjaxCall(theForm){
            $.ajax({
                url: $(theForm).attr('action'),
                type: $(theForm).attr('method'),
                data: $(theForm).serialize(),
                success: function(data){
                    $('.js-rep-locator-results').html(data.ViewResults);
                }
            })
        }
    }

    return {
        findARepForm: findARepForm
    }

}());